import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { type CountryResponse, MiscApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getCountriesEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getCountries(signal));
const clearEvent = createEvent();

const $dataStore = createStore<CountryResponse[]>([])
  .on(getCountriesEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getCountriesEffect.pending, (_, data) => data)
  .on(getCountriesEffect.fail, () => false)
  .on(getCountriesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCountriesEffect, () => null)
  // .on(getCountriesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCountriesEffect.fail, () => 'Something went wrong while fetching Countries. Please try again.')
  .on(getCountriesEffect.done, () => null)
  .reset(clearEvent);

export const $countriesStore = {
  events: {
    getCountries: ApiUtilsV2.wrapperApi(getCountriesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
